/**
 * @module views\sys\db\templates\dynamicProperty\otherProperty
 */
import Vue from "vue";
import Component from "vue-class-component";
import BaseEditor from "../../base";

@Component
export default class OtherProperty extends BaseEditor {}
